import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { MCEkuaibaoSDK } from '@ekuaibao/sdk-bridge/sdk/ekuaibao/indexMC';
import registerAPI from '../registerAPI';
import initializeTitle from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { initRoute } from '../initRoute';
import setNetworkAdapter from '../setNetworkAdapter';
import { fetchHandleError } from '../FetchConfig';
import { initColors } from '../initColors';
import { initUserInfo } from '../../lib/lib-util';
import initLogger from '../../logger/initLogger';
initLogger();
window.__PLANTFORM__ = 'MC';
function startup() {
    app.use({
        id: '@mc',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
fetchHandleError();
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initUserInfo(false);
                    initColors();
                    initRoute();
                    initPlatformInfo();
                    app.container.set('IDeviceType', 'DESKTOP');
                    app.container.set('ISMessageEntry', false);
                    app.sdk = app.container.get(MCEkuaibaoSDK);
                    registerHandler();
                    startup();
                    registerAPI();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4, app.sdk.initialize()];
                case 2:
                    _a.sent();
                    setNetworkAdapter();
                    return [3, 5];
                case 3:
                    e_1 = _a.sent();
                    console.log(e_1);
                    return [4, newHomeConfig()];
                case 4:
                    _a.sent();
                    setNetworkAdapter();
                    return [2];
                case 5: return [4, newHomeConfig()];
                case 6:
                    _a.sent();
                    initializeTitle();
                    return [2];
            }
        });
    });
}
